'use client';

import { showToast } from '@yanolja-rnd/nol-design-system';
import { useEffect } from 'react';
import { format } from 'date-fns';
import { ko } from 'date-fns/locale';

interface DateToastProps {
  show: boolean;
  checkInDate: string;
  checkOutDate: string;
  adult?: number;
  child?: number;
}

export const DateToast = ({ show, checkInDate, checkOutDate, adult, child }: DateToastProps) => {
  useEffect(() => {
    if (show) {
      const checkIn = format(checkInDate, 'MM.dd(EEE)', { locale: ko });
      const checkOut = format(checkOutDate, 'MM.dd(EEE)', { locale: ko });

      const message =
        adult || child
          ? `변경한 정보 ${checkIn} ~ ${checkOut} / 성인 ${adult}${child ? `/\n아동 ${child}` : ''}명으로 둘러보세요.`
          : `변경한 날짜로 ${checkIn} ~ ${checkOut}로 둘러보세요.`;

      showToast({ children: message });
    }
  }, [show]);

  return null;
};
